<nav class="container-menu" aria-label="Menu secondario">
  <div class="col-md-12 container-item-megamenu">
    @for (item of megamenu; track $index) {
    <div class="container-dropdown">
      <div class="nav-item" (mouseover)="item.isOpen = true" (mouseleave)="item.isOpen = false">
        @if(item.menu_label?.label) {
        <a data-bs-toggle="dropdown"
           class="dropdown-label"
           [routerLink]="[item.menu_label.path]"
           [attr.aria-expanded]="item.isOpen"
           [class.is-active-label]="item.isOpen">
          {{ item.menu_label.label }}
          @if(item?.dropdownItems) {
          <app-icon
            [name]="item.isOpen ? 'CaretUp' : 'CaretDown'"
            [size]="16"
            aria-hidden="true"
          />
          }
        </a>

        } @if(item.btn) {
        <a href="{{ item.btn.path }}"
           target="_blank"
           class="btn-sinistro">{{ item.btn.label }}</a>

        } @if(item.isOpen && item.dropdownItems) {

        <div class="dropdown-items">
          @for (link of item.dropdownItems; track $index) {
          <!-- Dropdown menu links -->
          <a class="items"
             [routerLink]="[link.path]"
             [queryParams]="{ id: link.id }"
          >{{ link.label }}</a>
          }
        </div>

        } @if(item.info) {
        <div (mouseover)="item.isOpen = true" (mouseleave)="item.isOpen = false" class="wrapper-info d-flex align-items-center">
          <span class="info-label">{{ item.info.label }}</span>
          <app-icon [name]="'Phone'" [size]="24" [color]="'medium-blue'" aria-hidden="true" />
          <span class="info-label number">{{ item.info.icon.label }}</span>
        </div>
        @if(item.isOpen) {
        <div class="menu-container menu-container-num">
          <div class="container-fluid">
            <img class="quote-up" src="assets/custom_icons/quote-arrow-down.svg" alt="arrow down" />
            <div class="row row-num">
              <div class="col-12">
                <p class="num">
                  <app-icon [name]="'Phone'" [size]="24" [color]="'dark-blue'" aria-hidden="true" />803.803</p>
                <p class="testo-num">Dall'Italia, attivo 24 h su 24.</p>
                <p class="num">
                  <app-icon [name]="'Phone'" [size]="24" [color]="'dark-blue'" aria-hidden="true" />+39 0258163803
                </p>
                <p class="testo-num">Chiama dall'estero</p>
              </div>
            </div>
          </div>
        </div>
        } }
      </div>
    </div>
    }
  </div>
</nav>
